import { retrievePortals as apiRetrievePortals } from '@/api/api'

export default {

  RETRIEVE_PORTALS: ({ commit }) => {
    return apiRetrievePortals().then(responseData => {
      commit('SET_PORTALS', { portals: responseData.response.data })
    }).catch(error => Promise.reject(error.response.data))
  }
}
